import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ItemInput = (props) => {
    const [expand, setExpand] = useState(false);
    const [commentText, setCommentText] = useState(props.question.commentText);
    const [responseText, setResponseText] = useState(props.question.responseText);
    const readMore = (e) => {
        e.preventDefault();
        setExpand(!expand);
    }

    return (
        <div className="itemBlock">
            <div className="item first">{props.question.questionText}               
            </div>
            <div className="item second"> 
                <select value={responseText} onChange={(e) => { props.handleItemChange(props.question.questionID, "responseText", e.target.value); setResponseText(e.target.value)}}>
                    <option value="" disabled>Choose One</option>      
                    <option value="Sufficient evidence">Sufficient evidence</option>
                    <option value="Some evidence">Some evidence</option>
                    <option value="No evidence">No evidence</option>
                    <option value="Not applicable">Not applicable</option>
                </select>
            </div>
            <div className="item third">
                <input type="text" maxLength="2000" placeholder="Comments" value={commentText} onChange={(e) => {props.handleItemChange(props.question.questionID, "commentText", e.target.value); setCommentText(e.target.value);}} />
            </div> 
            {props.question.questionInfo != "" ?
            <div className="item fourth">
                <a href="#" onClick={readMore} className="link-tiny">Read {expand ? "less -" : "more +"}</a>  
                    {expand ? <div dangerouslySetInnerHTML={{ __html: props.question.questionInfo }} /> : <div />}
                </div>
           : <React.Fragment />}
            
        </div>
    )
}
export default ItemInput;